{
  "build_id": "c8fad6f6aaa",
  "build_timestamp": 1790122183000,
  "environment": "prod",
  "version": "release-bw-tf-4.1.6"
}
